var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"zl-step"},_vm._l((_vm.stepArr),function(item,index){return _c('li',{key:index,class:{cur:_vm.active>=index},style:({
            width:_vm.width,
            color:_vm.active>=index?_vm.color||'#000':'#fff',
            'background':_vm.active>=index?_vm.background||'#F4F6FC':'#4E79CC'
        })},[_c('span',[_vm._v(_vm._s(index +1))]),_c('span',[_vm._v(_vm._s(item.title))]),(index<_vm.stepArr.length-1)?_c('div',{class:_vm.active>=index?'jiaoActive':'jiao',style:({
                color:_vm.active>=index?_vm.color||'#000':'#fff',
                'border-left-color':_vm.active>=index?_vm.background||'#F4F6FC':'#4E79CC'
            })}):_vm._e(),_c('div',{staticClass:"interval"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }